import {
  AuditLogEvent,
  Person,
  useGetMilestoneQuery
} from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  events: {
    createdBy?: Partial<Person> | null;
    createdTimestamp: DateTime;
    description: string;
    id: string;
    title: string;
  }[];
}

export function useQuery(id: string) {
  const tuple = useGetMilestoneQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.milestone?.id ?? '',
        events: tuple.data?.milestone?.auditLog.map((node) => ({
          id: node.id,
          title: node.title,
          createdBy: node.createdBy ?? null,
          description: `${node.createdBy?.fullName} ${node.description}`,
          createdTimestamp: node.createdTimestamp

        })) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
